import {
    buildSelectPromoModelInput,
    getPromozavrDebugParams,
    isPromozavrRouteAllowed,
} from '../../../../../common/helpers';
import type { InitPromozavrPayload, PromozavrRendererSource, SelectPromoModelInput } from './types';

type ResolvedPromozavrInit = {
    request: SelectPromoModelInput;
    requestKey: string;
    rendererSource: PromozavrRendererSource;
};

type ResolvePromozavrInitArgs = InitPromozavrPayload & {
    lang?: string;
    tld?: string;
    testIds?: string[];
    isYandexNet: boolean;
    shouldUsePaas: boolean;
    shouldUsePdokPromoRenderer: boolean;
};

export function resolvePromozavrInit(
    {
        pathname,
        search,
        requestKey,
        lang,
        tld,
        testIds = [],
        isYandexNet,
        shouldUsePaas,
        shouldUsePdokPromoRenderer,
    }: ResolvePromozavrInitArgs,
    resolveRendererSource: (shouldUsePdokPromoRenderer: boolean) => PromozavrRendererSource
): ResolvedPromozavrInit | undefined {
    if (!shouldUsePaas || !isPromozavrRouteAllowed(pathname)) {
        return;
    }

    const request = buildSelectPromoModelInput({
        lang,
        tld,
        testIds,
        debugParams: getPromozavrDebugParams(search, isYandexNet),
    });

    return {
        request,
        requestKey,
        rendererSource: resolveRendererSource(shouldUsePdokPromoRenderer),
    };
}
